export const MediaUrl = process.env.REACT_APP_WAGTAIL_URL;

export const  goToLegal = (callback) => {
    document.getElementById("legal-tagline").scrollIntoView({behavior: "smooth"});
    callback(true);
}
